export const LONG_PRESS_MS = 450

export const LONG_PRESS_TOLERANCE_PX = 10

const bindings = new WeakMap()

const movedTooFar = (touch, origin) =>
  !touch ||
  Math.hypot(touch.clientX - origin.x, touch.clientY - origin.y) >
    LONG_PRESS_TOLERANCE_PX

export const openIntent = {
  bind(el, binding) {
    const state = { callback: binding.value, timer: null, origin: null }
    const notify = () => {
      if (typeof state.callback === 'function') state.callback()
    }
    const release = () => {
      clearTimeout(state.timer)
      state.timer = null
      state.origin = null
    }
    const listeners = {
      auxclick: notify,
      contextmenu: notify,
      touchstart: event => {
        release()
        if (event.touches.length !== 1) return
        const [touch] = event.touches
        state.origin = { x: touch.clientX, y: touch.clientY }
        state.timer = setTimeout(() => {
          release()
          notify()
        }, LONG_PRESS_MS)
      },
      touchmove: event => {
        if (state.origin && movedTooFar(event.touches[0], state.origin)) {
          release()
        }
      },
      touchend: release,
      touchcancel: () => {
        const stillPressed = Boolean(state.timer)
        release()
        if (stillPressed) notify()
      },
    }
    Object.entries(listeners).forEach(([type, listener]) =>
      el.addEventListener(type, listener, { passive: true })
    )
    bindings.set(el, { state, listeners, release })
  },

  update(el, binding) {
    const bound = bindings.get(el)
    if (bound) bound.state.callback = binding.value
  },

  unbind(el) {
    const bound = bindings.get(el)
    if (!bound) return
    bound.release()
    Object.entries(bound.listeners).forEach(([type, listener]) =>
      el.removeEventListener(type, listener, { passive: true })
    )
    bindings.delete(el)
  },
}
